<script lang="ts">
  import Skeleton from './Skeleton.svelte';

  let {
    rows = 5,
    columns = 4,
    class: className = ''
  }: {
    rows?: number;
    columns?: number;
    class?: string;
  } = $props();

  const rowItems = $derived(Array.from({ length: rows }, (_, i) => i));
  const colItems = $derived(Array.from({ length: columns }, (_, i) => i));
</script>

<div class="table {className}" style="--cols: {columns};">
  {#each rowItems as r (r)}
    <div class="row">
      {#each colItems as c (c)}
        <Skeleton variant="text" width={c === 0 ? '40%' : '80%'} />
      {/each}
    </div>
  {/each}
</div>

<style>
  .table {
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
    padding: var(--space-2) 0;
  }

  .row {
    display: grid;
    grid-template-columns: repeat(var(--cols), 1fr);
    gap: var(--space-3);
    align-items: center;
    height: 32px;
    padding: 0 var(--space-3);
  }
</style>